import useTranslation from 'next-translate/useTranslation'

interface RecaptchaMessages {
  validationFailed: string
  unknownError: string
}

/** Pulls localized recaptcha messaging from recaptcha.json */
export const useRecaptchaMessages = (): RecaptchaMessages => {
  const { t } = useTranslation('recaptcha')

  const validationFailed = t('Errors.validationFail')
  const unknownError = t('Errors.unknownError')

  return { validationFailed, unknownError }
}
